import { render, staticRenderFns } from "./LoginHead.vue?vue&type=template&id=04b5f82c&scoped=true"
import script from "./LoginHead.vue?vue&type=script&lang=js"
export * from "./LoginHead.vue?vue&type=script&lang=js"
import style0 from "./LoginHead.vue?vue&type=style&index=0&id=04b5f82c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b5f82c",
  null
  
)

export default component.exports